import { useOutlet } from "react-router";
import styled from "styled-components";

import ParameterInventory from "./ParameterInventory";
import { CssSectionCard } from "../../components/styles";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const StyledWithParameterInventory = styled.div`
    background: #fafbfc;
    box-sizing: border-box;
    display: flex;
    height: 100vh;
    overflow: hidden;
    padding: 20px;

    & > * {
        flex: 1;
        min-height: 0;
        min-width: 0;
    }

    .section-card {
        ${ CssSectionCard }
    }
`;

export type ParameterOutletContext = UnsavedChangesContext;

export default function WithParameterInventory() {
    const guard = useUnsavedChangesRefs();

    const outlet = useOutlet(guard satisfies ParameterOutletContext);

    return (
        <StyledWithParameterInventory>
            {
                outlet ?? (
                    <div className="section-card">
                        <ParameterInventory guard={ guard } />
                    </div>
                )
            }
        </StyledWithParameterInventory>
    );
}
